import { render, staticRenderFns } from "./RiskTogglePofCof.vue?vue&type=template&id=c7eb872c&"
import script from "./RiskTogglePofCof.vue?vue&type=script&lang=js&"
export * from "./RiskTogglePofCof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports